// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","container":"Footer_container__iICw7","logo":"Footer_logo__w79hm","contacts":"Footer_contacts__kfY22","license":"Footer_license__UeNBU"};